var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.chartKey},[(_vm.fillRemainder)?_c('span',{staticClass:"remainder-filler"},[_c('span',{staticClass:"chart-body",style:({ width: _vm.width })})]):_c('span',{staticClass:"chart-body",style:({ width: _vm.width })})])}
var staticRenderFns = []

export { render, staticRenderFns }